module.exports = __webpack_public_path__ + "static/media/Afzuigkap.63abac05.mp3";